import { Navigate, useLocation } from "react-router-dom";

import { EmbedSummary } from "@/features/embed/EmbedSummary";
import { isEmbedded, readStoreName, topPanelUrl } from "@/features/embed/frame";
import { useEmbedSession } from "@/features/embed/useEmbedSession";
import { t } from "@/i18n";

/**
 * ikas admin icine gomulu hafif ozet — docs/faz3-ikas-spec.md §6 +
 * docs/faz5-arayuz-spec.md §2:
 *  - iframe DISINDA acilirsa (dogrudan sekme, paylasilan link) normal
 *    /ozet'e yonlendirilir — gomulu tasarim burada ANLAMSIZ.
 *  - iframe ICINDE: URL'den `storeName`, `POST /embedded-session` ile bearer;
 *    basarili olursa saglik halkasi + ilk 4 "ozet" karti + "Paneli tam ekran
 *    aç" (window.top, base'e saygili).
 *  - `embedded-session` 401 donerse YA DA onbellekteki (sessionStorage) bir
 *    bearer 2 saatlik omrunu ilk veri cagrisindan (bkz. EmbedSummary) SONRA
 *    doldurmus donerse — her iki durum da AYNI "tam ekranda giris yap"
 *    baglantisina cikar (useEmbedSession).
 *
 * NOT (App.tsx dokunulmaz — gorev kisiti; İNCELEME BULGUSU DUZELTMESI):
 * `/embed/ikas` rotasi App.tsx'te `RequireTenant` ile sarili; ikas admin'in
 * çapraz-site iframe'i içinde ANA oturum çerezi (SameSite=Lax) tarayici
 * tarafindan hiç gönderilmediğinden `RequireTenant` normalde bu bileseni hic
 * MOUNT ETMEDEN /giris'e yönlendirirdi (kritik bulgu). `RequireTenant`
 * (routes/guards.tsx) artik anonim + iframe ICINDE + tam olarak bu yol icin
 * yonlendirme YAPMAYIP dogrudan bu bileseni render eder — bearer akisi
 * (yukaridaki useEmbedSession) buradan itibaren HER ZAMAN calisir. Ayrica
 * backend `embedded_session_endpoint` artik ana cereze ek olarak dar kapsamli
 * `asakai_embed` cerezini de (SameSite=None, yalniz bu path) kabul eder (bkz.
 * backend/app/core/auth.py) — bu sayede "kullanici zaten cerezle girisliyse"
 * dali Chrome/Edge gibi 3.taraf cerezine izin veren tarayicilarda GERCEKTEN
 * calisir. Safari/Firefox/gizli mod gibi 3.taraf cerezini bloke eden
 * tarayicilarda bu cerez de ulasmaz — o durumda `embedded-session` 401 doner
 * ve kullanici zaten dogru tasarlanmis "tam ekranda giris yap" durumunu
 * gorur (bkz. gorev raporundaki "engeller").
 */
export function EmbedIkas() {
  const embedded = isEmbedded();
  // window.location.search DEGIL — react-router'in kendi location'i (MemoryRouter'da
  // (test) ve BrowserRouter'da (prod, basename VITE_BASE) ayni bicimde calisir.
  const location = useLocation();
  const storeName = readStoreName(location.search);
  const { status, reportInvalid } = useEmbedSession(storeName, embedded);

  if (!embedded) return <Navigate to="/ozet" replace />;

  const fullPanelHref = topPanelUrl("ozet");
  const fullLoginHref = topPanelUrl("giris");

  return (
    <div className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center p-4">
      <div className="card flex w-full flex-col items-center gap-4 text-center">
        <h1 className="font-display text-lg font-bold text-ink">{t("embed.title")}</h1>

        {status === "loading" && <p className="text-sm text-muted">{t("embed.loading")}</p>}

        {status === "unauthorized" && (
          <>
            <p className="text-sm text-muted">
              {t("embed.unauthorized")} {t("embed.unauthorized_hint")}
            </p>
            <a href={fullLoginHref} target="_top" rel="noreferrer" className="btn btn-primary">
              {t("embed.login_full")}
            </a>
          </>
        )}

        {status === "error" && <p className="text-sm text-red">{t("embed.error")}</p>}

        {status === "ready" && <EmbedSummary enabled onUnauthorized={reportInvalid} />}

        {status !== "unauthorized" && (
          <a href={fullPanelHref} target="_top" rel="noreferrer" className="btn btn-primary">
            {t("common.open_full_panel")}
          </a>
        )}
      </div>
    </div>
  );
}
